import { IId } from 'interfaces/common/common';

import { useQuery } from '@hooks/reactQuery';

import { getAssetAccess } from '@api/assetAccess';

import { extractQueryParams } from '@utils/common';

import { IAssetAccess } from '@interfaces/assets/assetAccess';

import { EUserRoles } from '@enums/common';

import { ASSET_ACCESS } from '@constants/queryKeys';

interface IUseQueryAssetAccessReturned {
	assetAccess?: IAssetAccess;
	isLoadingAssetAccess: boolean;
}

export const useQueryAssetAccess = ({ id }: IId): IUseQueryAssetAccessReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [ASSET_ACCESS, { id }],
		allowedRoles: [EUserRoles.platformOwnerAdministrator],
		queryFn: extractQueryParams(getAssetAccess),
		refetchOnWindowFocus: false,
		enabled: [!!id],
	});

	return {
		assetAccess: data,
		isLoadingAssetAccess: isInitialLoading,
	};
};
